// src/components/common/Layout.jsx
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

import Footer from '../common/Footer'
import Navbar from '../common/Navbar'
import Header from '../landing/Header'

export default function Layout({ children }) {
  const location = useLocation()
  const isLandingPage = location.pathname === '/'

  return (
    <>
      <Navbar />
      <div className="smooth-scroll-content" id="scrollsmoother-container">
        {isLandingPage && <Header />}
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
